/* Chặn cú NHÁY khi quiz chuyển màn.
 *
 * TRIỆU CHỨNG. Đổi câu hỏi thì màn mới hiện ra rồi mới "giật" một cái: chữ đổi, biểu tượng
 * đổi, vài khối xê dịch. Bản quiz cũ không có. Khách thấy hẫng đúng nhịp đang trả lời.
 *
 * ĐO ĐƯỢC (theme dev, bản production 03/09/2026, một lượt `goto()`):
 *     185ms  màn mới vẽ xong, `#app` đã về opacity 1 — KHÁCH ĐÃ NHÌN THẤY
 *     229ms  thêm MỘT đợt sửa DOM nữa: +550 ký tự HTML, một emoji thành thẻ <svg>
 *   tức 44ms sau khi màn hiện thì nó bị viết lại ngay trước mắt.
 *
 * VÌ SAO. Lớp hành vi v3 (nằm cuối `quiz-inner-weather.js`) treo một MutationObserver trên
 * `#app`, và trong callback nó `setTimeout(pass, 40)`. Cái `40` đó đẩy toàn bộ việc sửa ra
 * SAU khi trình duyệt đã vẽ. `pass()` chạy 20 hàm: đổi emoji thành icon SVG, dựng lại hàng
 * tầng, đo lại chiều cao rồi nắn đoạn văn, tô lại màu chữ…
 *
 * `goto()` fade ra 180ms rồi fade vào 220ms. Mốc 229ms rơi đúng GIỮA lúc fade vào.
 *
 * CÁCH VÁ. Không đụng file bê nguyên. Lớp v3 đã cố ý phơi `window.__v3pass` ra ngoài — chú
 * thích của chính nó ghi "để bộ đo gọi thẳng, khỏi đua với MutationObserver". Ta treo một
 * observer riêng gọi `__v3pass()` NGAY TRONG callback, không hoãn.
 *
 * Callback của MutationObserver là microtask: nó chạy XONG rồi trình duyệt mới vẽ khung
 * hình kế tiếp. Nên mọi thay đổi của `pass()` đã nằm sẵn trong lần vẽ đầu tiên — khách không
 * bao giờ thấy bản chưa sửa.
 *
 * Đo lại sau khi vá, 8 màn (q7duo · inter · multi7): số đợt sửa sau khi màn hiện = 0 ở TẤT CẢ.
 * Icon SVG vẫn đủ, không sót emoji nào. `pass()` tốn 0,3ms và idempotent — gọi lại không đổi
 * gì — nên chạy đồng bộ là an toàn, và lượt `setTimeout(pass, 40)` của lớp v3 sau đó thành
 * việc rỗng.
 *
 * PHẢI đứng SAU `quiz-inner-weather.js` (cần `__v3pass`) và SAU `quiz-anh-hop.js` (để ảnh đã
 * trỏ đúng trước khi `shapeProse` đo chiều cao). Cả hai đều `defer` nên chạy theo thứ tự tài
 * liệu. Bản quiz cũ không có `__v3pass` — file này tự thoát, không ảnh hưởng gì.
 */
(function () {
  if (typeof window.__v3pass !== 'function') return;   /* bản cũ — không có gì để gọi sớm */
  if (typeof MutationObserver !== 'function') return;

  var app = document.getElementById('app');
  if (!app) return;

  /* Chốt chống gọi lồng: `__v3pass()` tự sửa DOM nên sẽ đánh thức chính observer này.
     Không có chốt thì mỗi lần vẽ đẻ ra một chuỗi gọi lồng nhau. */
  var dangChay = false;

  function goiSom() {
    if (dangChay) return;
    dangChay = true;
    try { window.__v3pass(); } catch (e) { /* pass() đã tự bọc try từng hàm bên trong. */ }
    dangChay = false;
  }

  new MutationObserver(goiSom).observe(app, { childList: true, subtree: true });

  /* Màn đầu tiên do `boot()` vẽ có thể đã xong trước khi file này chạy — gọi một lần cho nó. */
  goiSom();
})();

/* ══════════════════════════════════════════════════════════════════════════
   PHẦN HAI — ĐỪNG CHỚP CẢ THẺ, CHỈ ĐỔI PHẦN THẬT SỰ ĐỔI
   ══════════════════════════════════════════════════════════════════════════

   Phần trên chặn được cú viết-lại-sau-khi-hiện (đo trên live: 0 đợt sửa sau khi
   màn hiện). Nhưng sếp vẫn thấy nháy, và tả rất đúng chỗ: "như kiểu load text".

   ĐO RA VÌ SAO. So HTML hai màn câu hỏi liên tiếp:

       giống nhau 3.069 ký tự đầu = 86% cả màn

   Toàn bộ `.topbar.tall` — thanh MINESPIRIT, hàng bảy icon tầng, nhãn
   "1 / 7 · Ground & Rest", đường kẻ — GIỐNG TỪNG BYTE giữa hai câu. Chỉ ~14%
   đổi: câu hỏi và thứ tự nhãn đáp án.

   Vậy mà `goto()` gốc mờ nguyên `#app` xuống 0 rồi dựng lại tất. Nghĩa là phần
   khung KHÔNG đổi cũng chớp tắt theo. Mắt không đọc đó là "sang câu mới" — mắt
   đọc là "trang vừa tải lại". Nền kem sáng càng làm cú chớp rõ.

   Rút nhịp (bản trước, 400ms -> 200ms) chỉ làm cú chớp NHANH hơn, không làm nó
   biến mất — đúng như sếp phản hồi.

   CÁCH SỬA. Bỏ hẳn việc mờ `#app`. Thay nội dung TỨC THÌ — phần khung được dựng
   lại y hệt trong cùng một khung hình nên mắt không thấy nó nhúc nhích — rồi chỉ
   cho phần ruột (`.mid` ở màn câu hỏi, `.docwrap` ở màn tài liệu) mờ dần lên.

   Kết quả: thanh trên và hàng icon tầng đứng yên tuyệt đối; chỉ chữ câu hỏi và
   dãy đáp án chuyển. Không còn quãng màn trống nào.

   Vẫn thay cả hàm chứ không sửa được bằng CSS: nhịp và opacity đều do `goto`
   ghi thẳng vào style inline mỗi lượt.

   An toàn: chép nguyên hợp đồng bản gốc — chốt biên, `navTimer`, `sfx('nav')`,
   `busy`, `clearTimers()`, `bindShell()`, `built.bind()`, `finally` để `busy`
   luôn được nhả. Vẫn thay NGUYÊN `innerHTML` như bản gốc, nên mọi việc gắn sự
   kiện giữ đúng thứ tự cũ — không giữ lại node nào để khỏi đẻ handler trùng.

   MUỐN TRẢ VỀ NHƯ CŨ: xoá nguyên khối này, phần trên vẫn chạy độc lập.
   Muốn đổi nhịp: sửa `RA` và `VAO`. */
(function () {
  var RA  = 70;    /* mờ phần ruột đi, ms  — bản gốc mờ CẢ #app 180ms */
  var VAO = 130;   /* mờ phần ruột lên, ms — bản gốc 220ms */

  if (typeof goto !== 'function' || typeof RENDER !== 'object') return;
  if (typeof window.__v3pass !== 'function') return;   /* chỉ áp cho bản v3 */

  /* Phần ruột của màn: cái đổi giữa hai câu. Thứ tự tìm theo độ hẹp dần.

     Chỉ nhận CON TRỰC TIẾP của `#scr`. Tìm sâu thì màn `expert` trả về thẻ ảnh
     chân dung `<img class="avsvg mid v7ph">` — `mid` ở đó là cỡ ảnh, không phải
     ruột màn — và cả màn coi như không có ruột để mờ. Màn nào không có ruột
     riêng thì rơi về `#scr`, tức mờ nguyên màn như bản gốc. */
  function ruot(goc) {
    var scr = goc.querySelector('#scr') || goc;
    return scr.querySelector(':scope > .mid') ||
           scr.querySelector(':scope > .docwrap') ||
           goc.firstElementChild;
  }

  /* Thay màn mà GIỮ LẠI node thanh trên khi nó không đổi.
     Vì sao đáng làm: hàng bảy icon tầng là bảy thẻ <svg> nội tuyến. Vứt đi rồi dựng lại mỗi
     câu là bắt trình duyệt vẽ lại cả bảy, và mọi hoạt hình/trạng thái trên đó bị đặt lại từ
     đầu. Giữ node thì chúng đứng nguyên, chỉ đổi nội dung khi thật sự có gì khác.

     An toàn vì `bindShell()` gắn sự kiện bằng PHÉP GÁN `onclick = …` (đo: `back`, `lgen`,
     `lgvi`, `sndb` đều vậy), không phải `addEventListener`. Gọi lại chỉ ghi đè đúng một
     handler, không đẻ handler trùng.

     Màn nào không có thanh trên (hoặc cấu trúc khác) thì rơi về cách cũ: thay nguyên. */
  function thayMan(app, html) {
    var scr = document.getElementById('scr');
    var tam = document.createElement('div');
    tam.innerHTML = html;
    var tbCu  = scr && scr.firstElementChild;
    var tbMoi = tam.firstElementChild;
    var duocGiu = scr && tbCu && tbMoi &&
                  tbCu.classList.contains('topbar') && tbMoi.classList.contains('topbar');

    if (!duocGiu) {
      app.innerHTML = '<div class="screen" id="scr">' + html + '</div>';
      return;
    }

    if (tbCu.className !== tbMoi.className) tbCu.className = tbMoi.className;
    if (tbCu.innerHTML !== tbMoi.innerHTML) tbCu.innerHTML = tbMoi.innerHTML;

    while (scr.children.length > 1) scr.removeChild(scr.lastElementChild);
    tam.removeChild(tbMoi);
    while (tam.firstChild) scr.appendChild(tam.firstChild);
  }

  window.goto = function (i) {
    if (i < 0 || i >= SCREENS.length) return;
    if (window.navTimer) { clearTimeout(window.navTimer); window.navTimer = null; }
    var doiMan = (i !== cur);
    if (doiMan) { try { sfx('nav'); } catch (e) {} }
    window.busy = true;
    try { clearTimers(); } catch (e) {}

    var app = document.getElementById('app');
    app.style.transition = '';
    app.style.opacity = '1';          /* #app KHÔNG mờ nữa — khung đứng yên */

    var cu = ruot(app);
    if (cu) {
      cu.style.transition = 'opacity ' + (RA / 1000) + 's ease';
      cu.style.opacity = '0';
    }

    window.navTimer = setTimeout(function () {
      window.navTimer = null;
      try {
        window.cur = i;
        var s = SCREENS[cur];
        var built = RENDER[s.t](s);
        thayMan(app, built.html);
        /* Sang màn khác thì luôn mở từ đầu trang (yêu cầu 29/09/2026). `thayMan` giữ lại
           node `#scr` — cái duy nhất cuộn — nên nếu không đặt lại, màn dài nối màn dài
           (hub → gd1off, credibility → social → vid) mở ra ở đúng độ cuộn của màn trước.
           Vẽ lại chính màn đang đứng (`goto(cur)`) thì giữ nguyên chỗ khách đang đọc. */
        if (doiMan) {
          var scrMoi = document.getElementById('scr');
          if (scrMoi) scrMoi.scrollTop = 0;
        }
        bindShell();
        if (built.bind) built.bind();
      } finally {
        var moi = ruot(app);
        /* Màn ra không có ruột riêng thì `cu` chính là `#scr`. Nếu màn vào lại
           tìm ra một ruột con, `moi` là node khác và `#scr` giữ nguyên
           `opacity:0` vừa đặt ở trên — cả màn vô hình vĩnh viễn (sập
           credibility→expert, hub→docMap, delivery→mapFull). Trả node cũ về
           trạng thái sạch trước khi mờ node mới lên. */
        if (cu && cu !== moi && cu.isConnected) {
          cu.style.removeProperty('transition');
          cu.style.removeProperty('opacity');
        }
        if (moi) {
          moi.style.transition = 'none';
          moi.style.opacity = '0';
          void moi.offsetHeight;      /* ép tính lại bố cục, không thì bỏ qua nhịp mờ */
          moi.style.transition = 'opacity ' + (VAO / 1000) + 's ease';
          moi.style.opacity = '1';
        }
        window.busy = false;          /* nhả kể cả khi ở trên ném lỗi */
      }
    }, cu ? RA : 0);
  };
})();
